export const PageNotFound = () => {
  return (
    <div className="p-4 text-center">
      <h1 className="text-3xl">404</h1>
      <p>Page not found</p>
    </div>
  );
};
